import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MemberService } from '../../../core/members/member.service';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormErrors } from '@app/shared/types/form-errors';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { TranslatePipe } from '@ngx-translate/core';

import { AppFocusableDirective } from '@app/shared/directives/focusable.directive';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { PasswordComponent } from '@app/shared/components/password/password.component';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    LoyaltyClubHeaderComponent,
    TopNavbarComponent,
    TranslatePipe,
    AppFocusableDirective,
    InputErrorsComponent,
    PasswordComponent,
    LoyaltyClubFooterComponent,
    FormsModule
],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private memberService = inject(MemberService);


  public form = this.formBuilder.group({
    current_password: ['', Validators.required],
    new_password: [''],
  });

  public formErrors: FormErrors = {};
  public isSubmitted = false;

  private unsubscribe$ = new Subject();

  public ngOnInit(): void {
    this.clearErrorsOnFormValuesChanges();
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public submit(): void {
    this.isSubmitted = true;

    if (!this.form.valid) {
      this.mapFormErrors();
      this.form.controls.new_password.updateValueAndValidity();
      return;
    }

    const body = {
      new_password_form: {
        password: this.form.controls.new_password.value,
        current_password: this.form.controls.current_password.value,
      },
    };
    this.memberService.changePassword(body).subscribe({
        next: () => this.router.navigate(['../..'], { relativeTo: this.route }),
        error: (response) => {
          this.onErrorSave(response.error.errors);
        },
      },
    );

  }

  private onErrorSave(errors: any): void {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length) {
      this.formErrors = {};
      errorKeys.forEach(property => this.formErrors[property] = { error: errors[property][0].error });
    }
  }

  private mapFormErrors(): void {
    Object.keys(this.form.controls).forEach(controlName => {
      const errors = this.form.get(controlName)?.errors;
      this.formErrors[controlName] = errors ? Object.keys(errors).map(errorKey => ({ error: errorKey }))[0] : null;
    });
  }

  private clearErrorsOnFormValuesChanges(): void {
    this.form.controls.current_password.valueChanges.pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(() => this.formErrors.current_password = null);
  }
}
